import { render, staticRenderFns } from "./editBorrowType.vue?vue&type=template&id=88b368ca"
import script from "./editBorrowType.vue?vue&type=script&lang=js"
export * from "./editBorrowType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports